<template>
    <div v-if="cert_data != null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center>
            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>

        <template>
            <div v-if="show == true" ref="document">
                <div class="printdiv">
                    <v-row justify="center">
                        <v-col cols="12" sm="3" md="3" align="center" style="margin-top: 30px">
                            <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo" width="155px"
                                height="110px" style="margin-left: -10px; margin-bottom: -10px" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="9" md="9" class="pb-0">
                            <b><span style="padding-left: 19%" v-if="org_basic_data.trust_name">{{
                                org_basic_data.trust_name }}</span></b>

                            <b>
                                <h1 style="text-align: left">
                                    {{ org_basic_data.school_name }}
                                </h1>
                            </b>
                            <b><v-col cols="12" sm="10" md="10" class="pb-0 pt-0 mr-10 header"
                                    style="text-align: center" v-if="org_basic_data.address">{{ org_basic_data.address
                                    }} - {{ org_basic_data.pin }}
                                    <br />
                                    <span class="marathi-matter">नोंदणी क्र. इसैशा / १०२००० / नसैशा / १५ क <br />
                                        शिक्षण संचालनालय, महाराष्ट्र राज्य, पुणे १, दि.
                                        १-८-२०००</span>
                                </v-col></b>
                        </v-col>
                    </v-row>
                    <br />
                    <center>
                        <h1 class="certificate-text">Character / Bonafide Certificate</h1>
                    </center>
                    <v-row justify="center" class="ml-2">
                        <v-col cols="12" sm="4" md="4">
                            <b>Reg. No. : SRES / SSS /{{ cert_data.cert_no }}</b>
                            <br />
                        </v-col>
                        <v-col cols="12" sm="5" md="5"></v-col>
                        <v-col align="right" cols="12" sm="3" md="3">
                            <b>
                                <span style="margin-right: 15%">Date : {{ cert_data.cert_date }}
                                </span>
                            </b>
                        </v-col>
                    </v-row>
                    <v-row class="main-row">
                        <v-col cols="12" sm="12" md="12" style="font-size: 1.3em; line-height: 250%;">
                            <div style="padding-left: 65px">This to Certify that,</div>
                            Mr./Miss
                            <b><span style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 86%;
                    display: inline-block;
                    line-height: 1;
                  ">{{ cert_data.stud_name }}</span></b>
                            <br />

                            <span>
                                is a bonafide student of this school. He is /was studying in
                                std.
                                <b><span style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    ">{{ cert_data.std }}</span></b>
                                in the
                            </span>
                            <br />

                            Year
                            <b><span style="
                    border-bottom: 2px solid #000;
                    width: 16%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  ">{{ cert_data.ay }}</span>.</b>
                            <br />
                            <div style="padding-left: 65px">
                                He bears a good moral character and he is an obedient and hard
                                working
                            </div>
                            <div>
                                student. He has passed / failed in std.
                                <b>
                                    <span style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    ">{{ cert_data.std }}</span></b>/S.S.C. /H.S.C./Examination
                            </div>
                            <div>
                                in April / March
                                <b><span style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 12%;
                      display: inline-block;
                      line-height: 1;
                    ">{{ cert_data.ay }}</span>.</b>His Birth date as per our school register is
                                <b>
                                    <span style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    ">
                                        {{ cert_data.dob }}
                                    </span></b>
                            </div>
                            <div>
                                (In words)
                                <b><span style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 84%;
                      display: inline-block;
                      line-height: 1;
                    ">{{ cert_data.dob_words }}</span></b>
                            </div>
                            <br />
                            G.R.No.:
                            <b><span>{{ cert_data.gr_no }}</span></b>
                            <br />
                            <br />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="5" md="5">
                            <div class="pl-8 font-size"><b>Seal</b></div>
                        </v-col>
                        <v-col cols="12" sm="7" md="7" class="font-size" style="text-align: center;">
                            <b>Principal</b> <br>
                            <b>SANJIVANI SAINIKI SCHOOL & JUNIOR COLLEGE,</b><br>
                            <b>Sahajanandnagar</b>
                        </v-col>
                    </v-row>
                    <br />
                    <br />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            fetch_loader: false,
            gen_cert_loader: false,
            show_cert_loader: false,
            search: "",
            rollno: "",
            dialog: false,
            awspath: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            data_list: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            cert_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            show: true,
            org_id: null,
            org_basic_data: [],
            progress: 0,
        };
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        close() {
            this.$router.push({ name: "get-Certificate-Report", target: "blank" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {

            this.cert_data = JSON.parse(localStorage.getItem("cert_data"));
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
            this.rollno = JSON.parse(localStorage.getItem("rollno"));

        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.org_id = localStorage.getItem("EPS-org-id");
        this.onload();
    },
};
</script>
<style scoped>
.certificate-text {
    font-size: 28px;
    font-family: "Times New Roman", Times, serif;
    text-transform: uppercase;
}

.text-css {
    float: left;
    font-weight: bolder;
    text-align: center;
}

.main-row {
    margin-left: 2px;
    margin-right: 2px;
}

.printdiv {
    padding: 10px;
    margin-left: 20%;
    margin-right: 20%;
    background-color: white;
    position: absolute;
}

.font-size {
    font-size: 14px;
}

@media print {
    .printdiv {
        width: 1450px;
        height: 1790px;
        padding-left: 100px;
        margin-left: -16px !important;
        margin-top: -105px !important;
        margin-right: -50px !important;
        font-size: 1.7em !important;
    }

    h1 {
        font-size: 55px !important;
        /* margin-bottom: 10px; */
    }

    .font-size {
        font-size: 30px;
    }

    .certificate-text {
        font-size: 55px !important;
    }

    .header {
        line-height: 170% !important;
        font-size: 28px !important;
        margin-top: 10px;
        text-align: center;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 220px !important;
        height: 190px !important;
        margin-top: 50px;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        /* size: 25.5in 19in; */
        size: 13.5in 16.5in !important;
    }

    * {
        overflow: hidden !important;
    }
}
</style>